import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { AirbrakeService } from "./airbrake.service";

@Injectable()
export class AirbrakeErrorHandler implements ErrorHandler {
  constructor(private airbrakeService: AirbrakeService) {}

  public handleError(error: any) {
    const isHttpErrorResponse = error instanceof HttpErrorResponse;

    if (!isHttpErrorResponse) {
      this.airbrakeService.notifier.notify(error);
    }

    // tslint:disable-next-line: no-console
    console.error(error);
  }
}
